<template>
  <div class="app-container">
    <el-card class="mb5">
      <el-form
        ref="form"
        :model="queryForm.params"
        label-width="auto"
        size="small"
        label-position="top"
      >
        <div class="searchContainer">
          <el-row :gutter="10">
            <el-col :span="6">
              <!--合同编号-->
              <el-form-item :label="$t('basicData.ContractNumber')" prop="contractNo">
                <el-input
                  v-model="queryForm.params.contractNo"
                  :placeholder="$t('GlobalSetObj.pleaseInput')"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--客户名称-->
              <el-form-item :label="$t('basicData.CustomerName')" prop="customerId">
                <QueryCustomerCmp :val="queryForm.params.customerId" :type="1" @change="val => queryForm.params.customerId = val" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--合同状态-->
              <el-form-item :label="$t('basicData.ContractStatus')" prop="statusList">
                <el-select
                  v-model="queryForm.params.statusList"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  style="width: 100%"
                  clearable
                  multiple
                >
                  <el-option
                    v-for="item in CONTRACT_STATUS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="searchResources"
      >
        {{ $t('operationCenter.Procurar') }}
      </el-button>
      <!--重 置-->
      <el-button
        size="small"
        icon="el-icon-refresh"
        @click="onReset"
      >{{ $t('basicData.reset') }}</el-button>
    </el-card>

    <el-card>
      <div class="feet-s mb10">
        <div class="feet-r">
          <!--新增-->
          <el-button
            v-permit:remove="'btn:basicData:contractLedger:add'"
            size="small"
            type="primary"
            icon="el-icon-plus"
            @click="onAdd(1)"
          >{{ $t('GlobalSetObj.add') }}</el-button>

          <!-- 导出 -->
          <el-popover
            placement="bottom-start"
            trigger="hover"
          >
            <div class="feet">
              <el-button
                v-permit:remove="'btn:basicData:contractLedger:export'"
                class="feet-btn"
                size="small"
                type="primary"
                @click="onExport(1)"
              >{{ $t('basicData.ExportOnlyListData') }}</el-button>
              <el-button
                v-permit:remove="'btn:basicData:contractLedger:take'"
                class="feet-btn"
                size="small"
                type="primary"
                @click="onExport(2)"
              >{{ $t('basicData.FullExportWithoutInvalidScannedDocuments') }}</el-button>
              <el-button
                v-permit:remove="'btn:basicData:contractLedger:exportAll'"
                class="feet-btn"
                size="small"
                type="primary"
                @click="onExport(3)"
              >{{ $t('basicData.FullExportWithInvalidScannedDocuments') }}</el-button>
            </div>
            <el-button
              slot="reference"
              size="small"
              type="info"
              icon="el-icon-download"
            >{{ $t('receivablePayable.Export') }}</el-button>
          </el-popover>

          <!--自定义栏目-->
          <CustomStatusBar
            class="feet-btn"
            :columns-data="columns"
            :params="searchParams"
            :save-params="customParams"
            @updateColumns="updateColumns"
          />
        </div>

      </div>

      <el-table
        ref="table"
        :key="tableKey"
        :data="tableData"
        class="table-height"
        :height="tableHeightRow.height"
        border
        row-key="idCopy"
        :tree-props="{ children: 'businessList', hasChildren: true }"
        :default-expand-all="true"
        @selection-change="handleSelectionChange"
      >
        <!-- 自定义多选列 -->
        <el-table-column label="" width="80" align="center">
          <template slot-scope="scope">
            <el-checkbox
              v-if="scope.row.isParent"
              :value="isChecked(scope.row)"
              @change="handleCheckChange(scope.row, $event)"
            />
          </template>
        </el-table-column>
        <el-table-column :label="$t('operationCenter.ind')" width="60px" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.isParent">{{ scope.row.parentIndex }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, ind) in currentColumns"
          :key="ind"
          :prop="item.prop"
          :label="item.label"
          :align="item.align"
          :min-width="item.width"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <!--            系统编号-->
            <span v-if="item.prop === 'serialNo'" class="serialNo">
              <span v-if="scope.row.isParent === true" class="batchNumber" @click="view(2, scope.row)">{{ scope.row.serialNo }}</span>
            </span>
            <!--            合同类型-->
            <span v-else-if="item.prop === 'type'">
              {{ CONTRACT_TYPE[scope.row.type] ? CONTRACT_TYPE[scope.row.type].label : '' }}
            </span>
            <!--            付款账期-->
            <span v-else-if="item.prop === 'paymentDays'">
              {{ CONTRACT_PERIOD[scope.row.paymentDays] ? CONTRACT_PERIOD[scope.row.paymentDays].label : '' }}
            </span>
            <!--            合同状态-->
            <span v-else-if="item.prop === 'status'">
              <el-tag
                :type="CONTRACT_STATUS[scope.row.status] ? CONTRACT_STATUS[scope.row.status].type : 'info'"
              >
                {{ CONTRACT_STATUS[scope.row.status] ? CONTRACT_STATUS[scope.row.status].label : '' }}
              </el-tag>
            </span>
            <!--            扫描件-->
            <span v-else-if="item.prop === 'fileList'">
              <div class="flex fileView">
                <template v-if="scope.row.fileList && scope.row.fileList.length > 0">
                  <!-- 显示前3个文件（按上传时间倒序） -->
                  <el-link
                    v-for="(key, index) in getDisplayFiles(scope.row.fileList)"
                    :key="key.id"
                    type="success"
                    @click="previewFile(scope.row, getOriginalIndex(scope.row.fileList, key))"
                  >{{ key.fileOriginalName }}</el-link>

                  <!-- 超过3个文件显示更多按钮 -->
                  <el-popover
                    v-if="scope.row.fileList.length > 3"
                    placement="bottom-start"
                    trigger="hover"
                    popper-class="file-list-popover"
                  >
                    <div class="file-list-container">
                      <div
                        v-for="(file, idx) in scope.row.fileList"
                        :key="file.id"
                        class="file-item"
                        @click="handleFileClick(scope.row, idx)"
                      >
                        <el-link type="success">{{ file.fileOriginalName }}</el-link>
                      </div>
                    </div>
                    <el-link slot="reference" type="primary">...({{ scope.row.fileList.length - 3 }})</el-link>
                  </el-popover>
                </template>
              </div>
            </span>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>

        <!--操作-->
        <el-table-column
          :label="$t('basicData.operate')"
          align="center"
          width="180"
          fixed="right"
          :show-overflow-tooltip="true"
        >
          <template #default="scope">
            <div v-if="scope.row.isParent" class="flex">
              <el-button
                v-permit:remove="'btn:basicData:contractLedger:edit'"
                class="ml"
                size="mini"
                @click="view(2, scope.row)"
              >{{ $t('basicData.View') }}</el-button>
              <!--删除-->
              <el-popconfirm
                :title="$t('basicData.AreYouSureDelete')"
                @confirm="Del(scope.row)"
              >
                <el-button
                  v-if="!scope.row.status"
                  slot="reference"
                  v-permit:remove="'btn:basicData:contractLedger:del'" type="danger"
                  size="mini"
                >{{ $t('basicData.Delete') }}</el-button>
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          style="margin: 10px 0"
          @current-change="getCurrentPage"
          @size-change="getSizePage"
        />
      </div>
    </el-card>

    <!--  合同详情  -->
    <el-drawer
      :append-to-body="true"
      :visible.sync="showDetail"
      :with-header="false"
      :wrapper-closable="false"
      direction="ltr"
      size="80%"
    >
      <Details
        :key="detailKey"
        :detail-type="detailType"
        :detail-data="detailData"
        @closeDetail="closeDetail"
      />
    </el-drawer>

    <!-- 文件预览对话框 -->
    <FilePreview
      v-if="showPreviewDialog" :file-list="currenFileList" :file-index="currentPreviewFile"
      @close="closeViewer"
    />
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es';
import { goFinanceExportPage } from '@/utils/goExportList.js';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import { CONTRACT_PERIOD, CONTRACT_STATUS, CONTRACT_TYPE } from '@/views/finance/enums.js';
import { columns } from './utils';
import {
  apiContractDelete,
  apiContractExport,
  apiContractExportAll,
  apiContractExportAllInvalid,
  apiContractGetPage
} from '@/api/finance/contractLedger';

export default {
  name: 'ContractLedger',

  components: {
    QueryCustomerCmp: () => import('@/views/finance/cmp/Query/QueryCustomerCmp.vue'),
    CustomStatusBar: () => import('@/components/customStatusBar/index.vue'),
    Details: () => import('./components/tabForm.vue'),
    FilePreview: () => import('@/views/finance/basicData/cope/accountsPayable/cmp/filePreview.vue')
  },

  mixins: [estimateTableHeight],

  data() {
    return {
      columns, // 表头
      CONTRACT_STATUS, // 合同状态
      CONTRACT_TYPE,
      CONTRACT_PERIOD,
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          contractNo: '', // 合同编号
          statusList: [], // 合同状态
          customerId: null // 客户ID
        }
      },
      selectData: [], // 勾选
      tableData: [], // 表格数据
      total: 0,
      tableKey: new Date().getTime(),

      showDetail: false,
      detailType: 1,
      detailData: {}, // 详情数据
      detailKey: new Date().getTime(),

      // 文件预览相关
      showPreviewDialog: false,
      currenFileList: [],
      currentPreviewFile: 0,

      currentColumns: [], // 自定义列
      searchParams: {
        type: 0,
        menuEnum: 'contractLedger'
      },
      customParams: {
        templateField: '',
        templateName: '合同台账',
        userId: '',
        type: 0,
        menuEnum: 'contractLedger'
      }
    };
  },

  computed: {

  },

  created() {
    // 获取合同列表
    this.getContractPage();
  },
  methods: {
    // 更新自定义栏目columns
    updateColumns(list) {
      this.$nextTick(() => {
        this.currentColumns = cloneDeep(list);
        this.tableKey = new Date().getTime();
      });
    },

    // 列表数据勾选
    handleSelectionChange(arr) {
      this.selectData = arr;
    },

    // 判断当前行是否被选中
    isChecked(row) {
      return this.selectData.some(item => item.id === row.id);
    },

    // 处理复选框变化
    handleCheckChange(row, checked) {
      if (checked) {
        // 选中：添加到数组
        if (!this.isChecked(row)) {
          this.selectData.push(row);
        }
      } else {
        // 取消选中：从数组中移除
        const index = this.selectData.findIndex(item => item.id === row.id);
        if (index > -1) {
          this.selectData.splice(index, 1);
        }
      }
      // 触发 selection-change 事件
      this.$emit('selection-change', this.selectData);
    },

    // 新增
    onAdd(type) {
      this.detailType = type;
      this.detailData = {};
      this.showDetail = true;
      this.detailKey = new Date().getTime();
    },

    // 查看
    view(type, row) {
      this.detailType = type;
      this.detailData = row;
      this.showDetail = true;
      this.detailKey = new Date().getTime();
    },

    // 删除
    Del(row) {
      apiContractDelete(row.id).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('basicData.TheOperationSucceeded'));
          this.searchResources();
        }
      }).catch(err => {
        console.log(err);
      });
    },

    // 关闭详情
    closeDetail() {
      this.showDetail = false;
      // 只在弹窗真正关闭时才刷新列表，避免重复调用
      if (this.showDetail === false) {
        this.searchResources();
      }
    },

    // 搜索
    searchResources() {
      this.queryForm.pageNumber = 1;
      this.getContractPage();
    },

    // 重置
    onReset() {
      this.$refs.form.resetFields();
      this.getContractPage();
    },

    // 翻页
    getCurrentPage(val) {
      this.queryForm.pageNumber = val;
      this.getContractPage();
    },

    // 每页显示数量变化
    getSizePage(val) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = val;
      this.getContractPage();
    },

    // 获取列表数据
    getContractPage() {
      const randomString = (e, t) => {
        // e选取字符长度; t字符串
        e = e || 4;
        const a = t.length;
        let n = '';
        for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
        return n;
      };

      function repeat(serialNo, random) {
        const randomStr = randomString(4, serialNo);
        if (!random.includes(randomStr)) {
          random.push(randomStr);
          return randomStr;
        } else {
          repeat(serialNo, random);
        }
      }

      function recurrence(table) {
        const randomArr = [];
        for (let i = 0; i < table.length; i++) {
          const randomId = repeat(table[i].serialNo, randomArr);
          table[i]['idCopy'] = table[i].id + randomId;
          if (table[i].businessList && table[i].businessList.length > 0) {
            recurrence(table[i].businessList);
          }
        }
        return table;
      }

      apiContractGetPage(this.queryForm).then(res => {
        const { code, data } = res;
        if (code === 200) {
          // 为父级记录添加序号
          data.records.forEach((item, index) => {
            item.isParent = true;
            item.parentIndex = (this.queryForm.pageNumber - 1) * this.queryForm.pageSize + index + 1;
            // 将父级数据同步到子级 businessList 中
            if (item.businessList && Array.isArray(item.businessList)) {
              item.businessList.forEach(child => {
                // 将父级的所有字段复制到子级（除了 businessList，fileList 本身）
                Object.keys(item).forEach(key => {
                  if (!['businessList', 'fileList'].includes(key)) {
                    child[key] = item[key];
                  }
                });
                // 标记子级
                child.isParent = false;
              });
            }
          });

          this.tableData = recurrence(data.records).map(item => ({
            ...item
          }));

          this.total = res.data.total;
        }
      }).catch(err => {
        console.error(err);
      });
    },

    // 导出
    // type 1 列表导出 2 导出生效扫描件 3 导出全部扫描件
    onExport(type) {
      const API = type === 1 ? apiContractExport : type === 2 ? apiContractExportAll : apiContractExportAllInvalid;
      console.log(API);
      API(this.queryForm.params).then(res => {
        if (res.code === 200) {
          goFinanceExportPage();
        }
      }).catch(err => {
        console.error(err);
      });
    },

    /**
     * 文件预览
     * @param file 预览的文件集合
     * @param index 当前索引
     */
    previewFile(file, index) {
      console.log(file);
      try {
        this.currentPreviewFile = index || 0;
        this.currenFileList = file.fileList.map(item => item.filePath) || [];
        this.showPreviewDialog = true;
      } catch (error) {
        console.error(error);
      }
    },

    // 关闭查看图片
    closeViewer() {
      this.showPreviewDialog = false;
    },

    /**
     * 获取显示的文件列表（前3个，按上传时间倒序）
     */
    getDisplayFiles(fileList) {
      if (!fileList || fileList.length === 0) return [];
      // 按上传时间倒序排序（假设有createTime字段）
      const sortedFiles = [...fileList].sort((a, b) => {
        const timeA = a.createTime || a.uploadTime || 0;
        const timeB = b.createTime || b.uploadTime || 0;
        return new Date(timeB) - new Date(timeA);
      });
      return sortedFiles.slice(0, 3);
    },

    /**
     * 获取文件在原始列表中的索引
     */
    getOriginalIndex(fileList, file) {
      return fileList.findIndex(item => item.id === file.id);
    },

    /**
     * 处理popover中文件点击
     */
    handleFileClick(row, index) {
      this.previewFile(row, index);
    }
  }
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
  gap: 10px;
}

.serialNo {
  color: #007efd;
  cursor: pointer;
}

.preview-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}

.text-center {
  text-align: center;
}

.fileView {
  flex-direction: column;
  align-items: flex-start;
}

::v-deep .file-list-popover {
  max-height: 400px;
  overflow-y: auto;
}

.file-list-container {
  .file-item {
    padding: 8px 0;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
      background-color: #f5f7fa;
    }

    &:not(:last-child) {
      border-bottom: 1px solid #ebeef5;
    }
  }
}
::v-deep .el-table__expand-icon{
  display: none !important;
}
</style>
